import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { LabManagerService } from '../lab-manager.service';
import { LabSubmissionDetailsModel } from 'src/app/models/lab-manager/lab-submission-details';
import { LabManagerSharedDataService } from '../lab-manager-shared-data.service';

@Component({
  selector: 'app-lab-soft-tissue-results-table',
  templateUrl: './lab-soft-tissue-results-table.component.html',
  styleUrl: './lab-soft-tissue-results-table.component.css',
  standalone: false
})
export class LabSoftTissueResultsTableComponent implements OnInit {

  @Input() sampleSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  labSubmissionDetails: LabSubmissionDetailsModel;
  searchText: string = '';
  pageSize: number = 9999;
  currentPage: number = 0;
  totalElements: number = 0;
  sampleColumns = [
    'farm',
    'field',
    'sample',
    'sampleReference',
    'crop',
    'cultivar',
    'blank',
    'nitrogen',
    'phosphorus',
    'potassium',
    'calcium',
    'magnesium',
    'sodium',
    'sulfur',
    // 'chlorine',
    'copper',
    'zinc',
    'manganese',
    'boron',
    'iron',
    'molybdenum'
  ];

  constructor(
    private nav: NavBarComponent,
    private labManagerService: LabManagerService,
    private labManagerSharedDataService: LabManagerSharedDataService
  ) {
    labManagerSharedDataService.labSubmissionDetailsData$.subscribe(res => {
      if(res) {
        this.labSubmissionDetails = res;
        this.retrieveLabResults();
      }
    })
  }

  ngOnInit(): void {
    
  }

  retrieveLabResults() {
    this.nav.toggleLoading(true);
    this.labManagerService.getSoftTissueLabResults(this.labSubmissionDetails.id, this.currentPage, this.pageSize).subscribe({
      next: (res) => {
        this.nav.toggleLoading(false);
        this.sampleSource = new MatTableDataSource<any>(res.content);
        this.totalElements = res.totalElements;
      },
      error: () => {
        this.nav.toggleLoading(false);
      }
    })
  }

  onPaginateChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.retrieveLabResults();
  }

}
